import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';
import { RiInformationLine } from 'react-icons/ri';
import { useMemo } from 'react';

import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';
import { useAppSelector } from '../../hooks/hooksRedux';

interface Props {
  content: string;
}

const StyledIcon = styled(RiInformationLine)<{ color: string }>`
  color: ${({ color }) => color};
  cursor: help;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

/** Em tooltips: onde houver "*" pula linha e remove o asterisco */
const contentWithLineBreakAtAsterisk = (text: string): string =>
  text?.includes('*') ? text.replace(/\*/g, '<br/>') : text;

const CustomTooltip = ({ content }: Props) => {
  const colors = useAppSelector((state: RootState) => state.styleGuide.data.colors);
  const primaryColor = colors.primary || defaultColors.primary;
  const htmlContent = contentWithLineBreakAtAsterisk(content ?? '');

  // Gerando ID único para cada tooltip para evitar conflitos no Safari
  const tooltipId = useMemo(() => `tooltip-${Math.random().toString(36).substr(2, 9)}`, []);

  return (
    <>
      <StyledIcon
        data-tooltip-id={tooltipId}
        data-tooltip-html={htmlContent}
        size={20}
        color={primaryColor}
      />
      <Tooltip id={tooltipId} className="z-50" style={{ maxWidth: 600 }} />
    </>
  );
};

export { CustomTooltip };
